import React from "react";
import { ConfigProvider } from "antd";
import { Outlet } from "react-router-dom";
import AnalyticsSubNav from "./AnalyticsSubNav";
import { analyticsAntTheme } from "./analyticsTheme";

const AnalyticsLayout = () => (
  <ConfigProvider theme={analyticsAntTheme}>
    <div className="main-wrapper analytics-dashboard-root">
      <div className="page-wrapper analytics-dashboard-root__page">
        <AnalyticsSubNav />
        <Outlet />
      </div>
    </div>
  </ConfigProvider>
);

export default AnalyticsLayout;
